export const collectionAnimationConfig = {
  competitionSwitchMs: 1000,
  scrollDurationMs: 1500,
  cardEnterDurationMs: 500,
  cardEnterDelayMs: 700,
};
